import Reveal from "./Reveal";
import { photoSrc } from "@/lib/api";

export default function LocationSection({ site }) {
  return <section className="location-section" id="location">
    <div className="container location-grid">
      <Reveal>
        <span className="eyebrow">Find us</span><h2 className="section-title location-title">Come hungry. Leave happy.</h2>
        <div className="location-info">
          <div className="info-block"><h3>Address</h3><p data-testid="business-address">{site.address}</p><a href="https://www.google.com/maps/search/?api=1&query=271+US-46+Mine+Hill+Township+NJ+07803" target="_blank" rel="noreferrer" data-testid="directions-link">Get directions ↗</a></div>
          <div className="info-block"><h3>Call</h3><a href="tel:+18624770684" data-testid="business-phone">{site.phone}</a><p>Questions, pickup, or just hungry? Give us a ring.</p></div>
        </div>
        <table className="hours-table" data-testid="business-hours"><caption>Hours · delivery / pickup</caption><thead><tr><th>Day</th><th>Delivery</th><th>Pickup</th></tr></thead><tbody>{site.hours.map((row) => <tr key={row.day}><td>{row.day}</td><td>{row.delivery}</td><td>{row.pickup}</td></tr>)}</tbody></table>
      </Reveal>
      <Reveal className="location-art"><img src={photoSrc(site.gallery?.[2]?.url || site.story_image_url)} alt={site.gallery?.[2]?.alt || "Pizza on a wooden table"} data-testid="location-pizza-image" /><div className="location-art-copy"><strong>Made for Mine Hill.</strong><span>Delivery · pickup · good company</span></div></Reveal>
    </div>
  </section>;
}
